import { RefObject, useEffect } from 'react';

export const useCloseOnEscape = (pillRef: RefObject<HTMLElement>, open: boolean, close: () => void) => {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || !pillRef.current?.contains(event.target as Node)) return;
      event.preventDefault();
      event.stopPropagation();
      close();
    };

    window.addEventListener('keydown', onKeyDown, true);

    return () => window.removeEventListener('keydown', onKeyDown, true);
  }, [pillRef, open, close]);
};
